import React from 'react'

import Button from '../button'
import Input from '../input'
import styles from '../../styles/modules/modal/modal.module.scss'
import { strings } from './modal-content'
import { Config } from '../../../core/toast'

interface Props {
  isLoading: boolean
  stationId: number
  createPreMakingTemplate: (
    stationId: number,
    name: string,
    description: string,
    templateType: string
  ) => void
  show: (config: Config) => void
}

interface State {
  readonly name: string
  readonly description: string
}

export class CreatePreMakingTemplateForm extends React.PureComponent<
  Props,
  State
> {
  readonly state = {
    name: '',
    description: '',
  }

  handleOnClickSubmit = () => {
    const { name, description } = this.state
    const { stationId } = this.props

    if (!name || !description) {
      const config: Config = {
        type: 'error',
        title: strings.toastError.title,
        body: 'テンプレート名と説明を入力してください',
      }
      this.props.show(config)
      return
    }

    // template_typeは'custom'固定
    this.props.createPreMakingTemplate(stationId, name, description, 'custom')
  }

  render() {
    const { isLoading } = this.props
    const { name, description } = this.state

    return (
      <main className={styles.main}>
        <Input
          label="テンプレート名"
          type={'text'}
          onChange={event => {
            this.setState({ name: event.target.value })
          }}
          value={name}
        />
        <Input
          label="説明"
          type={'text'}
          onChange={event => {
            this.setState({ description: event.target.value })
          }}
          value={description}
        />

        <Button
          title="作成する"
          onClick={this.handleOnClickSubmit}
          className={styles.decide}
          isLoading={isLoading}
        />
      </main>
    )
  }
}
